import { Component, Input } from '@angular/core';

@Component({
	selector: 'calendar-event-icon',
	templateUrl: './calendar-event-icon.component.html',
	styleUrls: ['./calendar-event-icon.component.scss'],
})
export class CalendarEventIconComponent {
	@Input() status;
	@Input() userRequestedReschedule;
}
